module.exports = require('./helpers/bundle-url').getBundleURL('6fvJB') + "logo.fb4fde20.svg";